import apiService from "../service/apiService";

export const fetchUserProfile = async (token: string) => {
  const profile = await apiService.MakeGetRequest(`users/me`, token);
  return profile;
};
